// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress[data-v-5bbad608]{display:flex;flex-direction:column;gap:16px}@media(max-width:985px){.progress[data-v-5bbad608]{padding:24px 20px 8px}}@media(min-width:986px){.progress[data-v-5bbad608]{padding:32px 20px 16px}}.progress__title[data-v-5bbad608]{align-items:center;display:flex;gap:8px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
